import { apiFetch } from '@/lib/api-client';
import type { NoteSnippet, PrivateNote, NotesResponse, FavoriteTicketOption } from '@uniticket/shared';

// Onglet « Notes ». Une seule lecture sert les deux bibliothèques : les réponses partagées ET les
// notes privées de l'appelant — le serveur ne renvoie jamais celles d'un autre, il n'y a rien à
// filtrer ici. Tout est chargé en une fois : recherche, tri et pagination se font à l'écran (décision
// du 10-09), donc aucune frappe ne déclenche d'appel.

const json = (body: unknown) => ({
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify(body),
});

export function fetchNotes() {
  return apiFetch<{ data: NotesResponse }>('/notes');
}

// ── Réponses partagées (admin) — une entrée à la fois, jamais la liste entière ──
export function createSnippet(title: string, body: string) {
  return apiFetch<{ data: NoteSnippet }>('/notes/snippets', { method: 'POST', ...json({ title, body }) });
}
export function updateSnippet(id: string, title: string, body: string) {
  return apiFetch<{ data: NoteSnippet }>(`/notes/snippets/${encodeURIComponent(id)}`, { method: 'PUT', ...json({ title, body }) });
}
export function deleteSnippet(id: string) {
  return apiFetch<{ data: { ok: true } }>(`/notes/snippets/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

/** Les tickets qu'on peut rattacher à une note : SES favoris. Chargé à l'ouverture de la modale —
 *  la plupart des notes ne sont rattachées à rien. */
export function fetchLinkableTickets() {
  return apiFetch<{ data: FavoriteTicketOption[] }>('/notes/linkable-tickets');
}

// ── Notes privées — toujours les siennes, le serveur prend l'identité dans le jeton ──
// `ticketId` est toujours envoyé, `null` compris : c'est ce qui permet de DÉTACHER une note.
export function createNote(title: string, body: string, ticketId: string | null) {
  return apiFetch<{ data: PrivateNote }>('/notes/me', { method: 'POST', ...json({ title, body, ticketId }) });
}
export function updateNote(id: string, title: string, body: string, ticketId: string | null) {
  return apiFetch<{ data: PrivateNote }>(`/notes/me/${encodeURIComponent(id)}`, { method: 'PUT', ...json({ title, body, ticketId }) });
}
export function deleteNote(id: string) {
  return apiFetch<{ data: { ok: true } }>(`/notes/me/${encodeURIComponent(id)}`, { method: 'DELETE' });
}
